const ANSIColor = {
  Reset: '\x1b[0m',
  Dim: '\x1b[2m',
  Green: '\x1b[32m',
  Red: '\x1b[31m',
  Yellow: '\x1b[33m',
  Underscore: '\x1b[4m',
  DarkBlue: '\x1b[34m',
  Blue: '\x1b[36m',
  BrightGreen: '\x1b[92m',
  CyanBg: '\x1b[46m',
} as const;

type ANSIColor = typeof ANSIColor[keyof typeof ANSIColor];

export { ANSIColor };
